import React, { useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import "./about.scss";
import { Container, Row, Col} from "react-bootstrap";
import GlitchLines from '../../components/glitchLines/glitchLines';
import LetsTalk from '../../components/letsTalk/letsTalk';
import { useAnimationContext } from '../../AnimationContext';


const About = () => {
    const { isPreloaderComplete } = useAnimationContext();
    const parentRef = useRef(null);
    const location = useLocation();

    useEffect(() => {
        if (location.pathname === '/about') {
            const dpImage = document.querySelector('.dpImage');
            if (dpImage) {
                dpImage.style.opacity = '1';
            }
        }
    }, [location]);

  return (
    <div ref={parentRef}>
        <GlitchLines parentRef={parentRef} />
        <svg className="glitchLines">
            <defs>
                <filter id="noise">
                    <feTurbulence type="fractalNoise" baseFrequency="0.05" numOctaves="5" result="noise" seed="10" />
                    <feDisplacementMap in="SourceGraphic" in2="noise" scale="10" xChannelSelector="R" yChannelSelector="G" />
                </filter>
            </defs>
            <g className="d-none d-lg-block">
            <line x1="0" y1="30%" x2="55%" y2="100%" />
            <line x1="0" y1="88%" x2="47%" y2="0" />
            <line x1="75%" y1="0" x2="100%" y2="30%" />
            <line x1="60%" y1="100%" x2="100%" y2="4%" />
            </g>
            <g className="d-lg-none">
            <line x1="20%" y1="0" x2="100%" y2="20%" />
            <line x1="0" y1="40%" x2="100%" y2="53%" />
            <line x1="0" y1="57%" x2="100%" y2="7%" />
            </g>
        </svg>
        <section id="secAbout">
            <Container fluid id="contAbout">
            <Row>
                <Col lg={4} className="d-flex flex-column align-items-center">
                    <h1 className={`d-lg-none headerText ${isPreloaderComplete ? 'headerTextHighlight' : ''}`}>About Me</h1>
                    <div className={`d-none d-lg-block ${isPreloaderComplete ? 'dpImage' : ''}`}></div>
                </Col>
                <Col lg={8} className="colRight">
                    <div className="d-flex justify-content-center">
                        <h1 className={`d-none d-lg-block headerText ${isPreloaderComplete ? 'headerTextHighlight' : ''}`} style={{ marginBottom: 'calc(1.5rem + 2vh)' }}>Vernon Eliamani</h1>
                    </div>
                    <Row>
                        <Col xs={6} className="d-lg-none" style={{ paddingLeft: 0 }}>
                            <div className={`${isPreloaderComplete ? 'dpImage' : ''}`}></div>
                        </Col>
                        <Col xs={6} lg={12} id="attrColumn" className={`${isPreloaderComplete ? 'attrColumn' : ''}`}>
                            <Row>
                                <Col xs={'auto'} xl={7}>
                                    <div className="d-flex flex-column flex-md-row">
                                        <h5 className="attrName">Generation:</h5>
                                        <h5 className="attrData">Millennial</h5>
                                    </div>
                                    <div className="d-flex flex-column flex-md-row">
                                        <h5 className="attrName">Education:</h5>
                                        <div>
                                            <h5 className="attrData">B.A. Corporate Communication</h5>
                                            <p id="MMU">Multimedia University of Kenya</p>
                                        </div>
                                    </div>
                                    <div className="d-flex flex-column flex-md-row">
                                        <h5 className="attrName">Religion:</h5>
                                        <h5 className="attrData">Christian</h5>
                                    </div>
                                </Col>
                                <Col xs={"auto"}>
                                    <div className="d-flex flex-column flex-md-row">
                                        <h5 className="attrName">Home:</h5>
                                        <h5 className="attrData">Tanzania</h5>
                                    </div>
                                    <div className="d-flex flex-column flex-md-row">
                                        <h5 className="attrName">Language:</h5>
                                        <h5 className="attrData">English, Swahili</h5>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={12} id="AboutTextCol">
                            <p>Before I started school, I was playing with water paint, crayons, markers, and an endless supply of paper. I cannot imagine a world without color.
                            <br /><br />I put together my design skills and creativity to write stories in people's minds through holistic design.
                            <br /><br />When I’m not working or learning new creative skills, I am either playing a computer game, golf, basketball, or the piano. When feeling more adventurous, I love exploring the outdoors with good company.
                            </p>
                        </Col>
                    </Row>
                </Col>
            </Row>
            </Container>
            <LetsTalk />
    </section>
    
   </div>
  );
}

export default About;